"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forcePoolKeyHash = void 0;
var cardano_ledger_ts_1 = require("@harmoniclabs/cardano-ledger-ts");
var crypto_1 = require("@harmoniclabs/crypto");
var uint8array_utils_1 = require("@harmoniclabs/uint8array-utils");
function forcePoolKeyHash(canBe) {
    if (typeof canBe === "string") {
        if (canBe.startsWith("pool")) {
            var _a = __read((0, crypto_1.decodeBech32)(canBe), 2), _hrp = _a[0], decoded = _a[1];
            return new cardano_ledger_ts_1.PoolKeyHash(new Uint8Array(decoded));
        }
        return new cardano_ledger_ts_1.PoolKeyHash((0, uint8array_utils_1.fromHex)(canBe));
    }
    return new cardano_ledger_ts_1.PoolKeyHash(canBe);
}
exports.forcePoolKeyHash = forcePoolKeyHash;
